import styled from 'styled-components'

export const TitleBlockWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`
